import React, { PropsWithChildren, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ErrorPage } from "Components/ErrorPage";
import { ThemedSpinner } from "Components/Themes/components/ThemedSpinner";
import { IllustrationName } from "Constants/constants";
import { ReduxState } from "Store/rootReducer";
import { TextLanguage } from "Store/texts/interfaces";
import { textRequested } from "Store/texts/slice";
import { isDefined } from "Utils/functions";

const errorMessages = {
  [TextLanguage.NORWEGIAN_BOKMAAL]: {
    title: "Noe gikk galt!",
    paragraphs: [
      "Noe gikk galt under innlasting av siden og vi greide ikke å starte opp tjenesten.",
    ],
  },
  [TextLanguage.ENGLISH]: {
    title: "Something unexpected occured!",
    paragraphs: [
      "Something unexpected occured while loading the site and we are therefore unable to start up the service.",
    ],
  },
};

interface Props {
  documentId?: string;
}

export const FMSTextLoader = ({
  documentId,
  children,
}: PropsWithChildren<Props>): React.ReactElement => {
  const { domain, error, language } = useSelector(
    (state: ReduxState) => state.texts,
  );
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(textRequested(documentId ?? window.env.FMS_DOCUMENT));
  }, []);

  if (!isDefined(domain) && isDefined(error)) {
    return (
      <ErrorPage
        title={errorMessages[language].title}
        paragraphs={errorMessages[language].paragraphs}
        illustrationName={IllustrationName.CUSTOMER_SERVICE_WOMAN}
      />
    );
  }

  if (!isDefined(domain)) {
    return <ThemedSpinner />;
  }

  return <>{children}</>;
};
